import type { CameraId } from '@cguard/types';

export interface CameraSearch {
  readonly cameraId?: string;
}

export function parseCameraSearch(search: Record<string, unknown>): CameraSearch {
  const cameraId = search.cameraId;
  return typeof cameraId === 'string' && cameraId.trim() !== '' ? { cameraId } : {};
}

export function resolveCameraSelection(
  cameras: ReadonlyArray<{ readonly id: CameraId }>,
  requestedCameraId: string | undefined,
): CameraId | null {
  return cameras.find((camera) => camera.id === requestedCameraId)?.id ?? cameras[0]?.id ?? null;
}
